
/**
 * 뉴스 출처 정보
 */
export type GetExploreContent200PageAllOfThreeContentItemContentOneOfFivezeroSource = {
  name?: string;
  url?: string;
};
